export default {
    Title: 'Tham số báo cáo',
    Year: 'Chọn kỳ báo cáo',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    DecisionDateLabel: 'Ngày',
    ViewReport: 'Xem báo cáo',
    Cancel: 'Hủy',
    Description: '2. Nhận xét, kiến nghị',
    CheckBoxShowData: 'Hiển thị số liệu của cơ quan thanh toán vốn'
  };
  